import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState, useRef } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { userAction } from '../../actions/userAction';
import { DABInlineLoading } from '../../components/dab';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';

interface IUserProps {
	dispatch: Dispatch<any>;
	userData: any;
}

const CommunityGrowth: React.SFC<IUserProps> = ({ dispatch, userData }) => {

	const [isUserCountByYearLoaded, setIsUserCountByYearLoaded] = useState(false);
	const [usersCountByYearGraphOptions, setUsersCountByYearGraphOptions] = useState({});
	const barChartSingleComponentRef = useRef<HighchartsReact.RefObject>(null);

	const year: number = moment().year()

	const handleRefreshGraph = (userCountData, year) => {
		setUsersCountByYearGraphOptions({
			title: {
				text: 'Registered Users'
			},
			xAxis: {
				categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			},
			yAxis: {
				min: 0,
				title: {
					text: 'Number Of Users'
				}
			},
			plotOptions: {
				hover: {
					enabled: false
				},
				series: {
					allowPointSelect: true,
				}
			},
			series: [{
				name: year,
				data: userCountData
			}]
		});
	};

	React.useEffect(() => {
		dispatch(userAction.userGetCountByYear(year));
	}, []);

	if (!isUserCountByYearLoaded && userData.isUserCountByYearLoaded) {
		setIsUserCountByYearLoaded(true);
		if (userData.usersCount) {
			var data = [{}]; data.splice(0);
			userData.usersCount.forEach((item) => {
				data.push(item.count);
			});			
			handleRefreshGraph(data, year);
		}
	}


	return (
		<div className="community-growth">
			<h5>
				<span data-testid="comunityGrowthChartTitle">Community Growth</span>
			</h5>
			{userData && userData.usersCount && userData.usersCount.length > 0 ?
				<div className='card-box'>
				<div className='card-box-graph' data-testid="comunityGrowthChart">
					{userData.isUserCountLoading ? <DABInlineLoading /> :
						<HighchartsReact
							containerProps={{ style: { height: "400px", width: "100%", padding: "0" } }}
							highcharts={Highcharts}
							options={usersCountByYearGraphOptions}
							ref={barChartSingleComponentRef}
						/>}
				</div>
			</div>:
			<div className="card-box on-empty"><h5 className="text-center">No data found</h5></div>}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { userData } = state;
	return {
		userData
	};
};

export default connect(mapStateToProps)(CommunityGrowth);